import { render } from "./ContextComparison.vue?vue&type=template&id=11590c49&scoped=true"
import script from "./ContextComparison.vue?vue&type=script&lang=js"
export * from "./ContextComparison.vue?vue&type=script&lang=js"

import "./ContextComparison.vue?vue&type=style&index=0&id=11590c49&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11590c49"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn,QInnerLoading});
